import { useState } from "react";
import { faqs } from "@/mocks/campus";
import SectionHead from "./SectionHead";
import Reveal from "./Reveal";
import JsonLd from "./JsonLd";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  const toggle = (idx: number) => setOpenIdx((cur) => (cur === idx ? -1 : idx));

  const faqJson = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-accent-50/60 scroll-mt-24">
      <JsonLd data={faqJson} />
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <Reveal>
          <SectionHead
            eyebrow="吃瓜指南"
            title="关于围观，你可能想问这些"
            desc="一个合格的吃瓜群众，既要看得热闹，也要读得懂规则。先把这些基本问题弄清楚再下场不迟。"
          />
        </Reveal>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <Reveal key={idx} delay={(idx % 4) * 60}>
                <div className={`overflow-hidden rounded-2xl bg-background-50 ring-1 transition-colors ${open ? "ring-primary-300" : "ring-background-200"}`}>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => toggle(idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                        Q
                      </span>
                      <span className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
                    </span>
                    <i className={`text-lg text-foreground-400 transition-transform duration-300 ${open ? "rotate-45 text-primary-500" : ""} ${open ? "ri-subtract-line" : "ri-add-line"}`} />
                  </button>
                  {open ? (
                    <div className="border-t border-background-200/70 px-5 py-4 md:px-6">
                      <p className="flex gap-3 text-sm leading-relaxed text-foreground-700">
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-800">A</span>
                        {item.a}
                      </p>
                    </div>
                  ) : null}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}